import * as React from 'react';
import { Box,Backdrop, Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

const API = require("../../data/network/API");

const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: "environment",
};

const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );

export default function  Photo () {
  const webcamRef = useRef(null);
  const [open, setOpen] = React.useState(false);
  const [imgSrc, setImgSrc] = useState(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
  }, [webcamRef, setImgSrc]);

  return (
    <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3, mt:10 }}>    
        <div sx={{ my: 1, mx: 'auto', p: 1 }}>
            <Grid container spacing={1} >
                <Grid item xs={12} sm={8} md={7}>
                    <Stack spacing={2} sx={{width:"100%"}}>
                        <Typography variant="h6" sx={{fontWeight: "bold"}}>¿Como funciona?</Typography>
                        <Typography variant="caption">{bull} Toma foto de un producto en tienda.</Typography>
                        <Typography variant="caption">{bull} Se valida el producto en la foto.</Typography>
                        <Typography variant="caption">{bull} Al validar la foto, se asignan los puntos correspondientes</Typography>
                        
                        <Webcam
                            audio={false}
                            ref={webcamRef}
                            mirrored={true}
                            screenshotFormat="image/jpeg"
                            videoConstraints={videoConstraints}
                            minScreenshotWidth={180}
                            minScreenshotHeight={180}
                        />
                        <Button onClick={capture} color='secondary' variant='contained'>Capture Photo</Button>
                        {imgSrc && <img src={imgSrc} alt="img" />}
                    </Stack>
                </Grid>
                <Grid item  xs={1}sm={4} md={5}/>
            </Grid>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    </Box>
  );
};